<form
  [formGroup]="bankAccountForm"
  (ngSubmit)="onSave()"
  class="flex flex-col gap-6"
  [dir]="locale.startsWith('ar') ? 'rtl' : 'ltr'">
  <div class="bgWhiteColor rounded-2xl p-6 shadow-md">
    <div class="grid grid-cols-2 gap-6">
      <div class="flex flex-col gap-2">
        <label class="textTableHeaderColor text-sm font-bold">
          <span i18n="@@adminBankNameArabicLabel">Bank Name (Arabic)</span>
          <span class="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Enter bank name in Arabic"
          i18n-placeholder="@@adminBankNameArabicPlaceholder"
          formControlName="bankNameArabic"
          [class.invalid-field]="
            bankAccountForm.controls.bankNameArabic.invalid && bankAccountForm.controls.bankNameArabic.touched
          "
          class="borderhelperColorOne bgWhiteColor focus:borderPrimaryColor rounded-lg border px-3 py-2 text-sm transition-all outline-none placeholder:text-[var(--placeholderColor)]" />

        @if (bankAccountForm.controls.bankNameArabic.touched) {
          @if (bankAccountForm.controls.bankNameArabic.hasError("required")) {
            <small class="validation-error" i18n="@@adminBankNameArabicRequired">Bank Name (Arabic) is required</small>
          }
        }
      </div>
      <div class="flex flex-col gap-2">
        <label class="textTableHeaderColor text-sm font-bold" i18n="@@adminBankNameEnglishLabel">
          Bank Name (English)
        </label>

        <input
          type="text"
          placeholder="Enter bank name in English (optional)"
          i18n-placeholder="@@adminBankNameEnglishPlaceholder"
          formControlName="bankNameEnglish"
          [class.invalid-field]="
            bankAccountForm.controls.bankNameEnglish.invalid && bankAccountForm.controls.bankNameEnglish.touched
          "
          class="borderhelperColorOne bgWhiteColor focus:borderPrimaryColor rounded-lg border px-3 py-2 text-sm transition-all outline-none placeholder:text-[var(--placeholderColor)]" />
      </div>
      <div class="flex flex-col gap-2">
        <label class="textTableHeaderColor text-sm font-bold" i18n="@@adminBankAccountNumberLabel">
          Account Number
          <span class="required">*</span>
        </label>

        <input
          type="text"
          placeholder="Enter account number"
          i18n-placeholder="@@adminAccountNumberPlaceholder"
          formControlName="accountNumber"
          maxlength="30"
          inputmode="numeric"
          [class.invalid-field]="
            bankAccountForm.controls.accountNumber.invalid && bankAccountForm.controls.accountNumber.touched
          "
          class="borderhelperColorOne bgWhiteColor focus:borderPrimaryColor rounded-lg border px-3 py-2 text-sm transition-all outline-none placeholder:text-[var(--placeholderColor)]" />

        @if (bankAccountForm.controls.accountNumber.touched) {
          @if (bankAccountForm.controls.accountNumber.hasError("required")) {
            <small class="validation-error" i18n="@@adminAccountNumberRequired">Account number is required</small>
          } @else if (bankAccountForm.controls.accountNumber.hasError("pattern")) {
            <small class="validation-error" i18n="@@adminAccountNumberNumbersOnly">
              Account number must contain numbers only
            </small>
          } @else if (
            bankAccountForm.controls.accountNumber.hasError("minlength") ||
            bankAccountForm.controls.accountNumber.hasError("maxlength")
          ) {
            <small class="validation-error" i18n="@@adminAccountNumberLength">
              Account number must be between 8 and 30 digits
            </small>
          }
        }
      </div>

      <div class="flex flex-col gap-2">
        <label class="textTableHeaderColor text-sm font-bold" i18n="@@adminIBANLabel">
          IBAN
          <span class="required">*</span>
        </label>

        <input
          type="text"
          placeholder="Enter IBAN"
          i18n-placeholder="@@adminIBANPlaceholder"
          formControlName="iban"
          maxlength="34"
          [class.invalid-field]="bankAccountForm.controls.iban.invalid && bankAccountForm.controls.iban.touched"
          class="borderhelperColorOne bgWhiteColor focus:borderPrimaryColor rounded-lg border px-3 py-2 text-sm uppercase transition-all outline-none placeholder:text-[var(--placeholderColor)]" />

        @if (bankAccountForm.controls.iban.touched) {
          @if (bankAccountForm.controls.iban.hasError("required")) {
            <small class="validation-error" i18n="@@adminIBANRequired">IBAN is required</small>
          } @else if (bankAccountForm.controls.iban.hasError("invalidIban")) {
            <small class="validation-error" i18n="@@adminIBANInvalid">Please enter a valid IBAN</small>
          } @else if (bankAccountForm.controls.iban.hasError("specialCharacters")) {
            <small class="validation-error" i18n="@@adminIBANSpecialCharacters">
              Special characters are not allowed
            </small>
          } @else if (
            bankAccountForm.controls.iban.hasError("minlength") || bankAccountForm.controls.iban.hasError("maxlength")
          ) {
            <small class="validation-error" i18n="@@adminIBANLength">
              IBAN length must be between 15 and 34 characters
            </small>
          }
        }
      </div>
    </div>
    <div class="mt-24 flex justify-end gap-3">
      <button
        type="button"
        (click)="onCancel()"
        class="cancel-button hover-bg-primary-10 h-10 w-28 rounded-[6px] border text-[13px] font-[500] hover:cursor-pointer">
        <span i18n="@@cancel">Cancel</span>
      </button>
      <app-submit-button type="primary" class="h-10 w-28">
        <span i18n="@@save">Save</span>
      </app-submit-button>
    </div>
  </div>
</form>
